import { apiClient } from '../../services/apiClient';
import type { BannerLayout, BannerLayoutTemplate } from './types';

/** 個人テンプレート API (backend/routes/banner_layouts.py) */
export async function fetchBannerLayoutTemplates(): Promise<BannerLayoutTemplate[]> {
  const { data } = await apiClient.get<{ templates: BannerLayoutTemplate[] }>('/banner-layouts');
  return data.templates ?? [];
}

export async function createBannerLayoutTemplate(name: string, layout: BannerLayout): Promise<BannerLayoutTemplate> {
  const { data } = await apiClient.post<{ template: BannerLayoutTemplate }>('/banner-layouts', { name, layout });
  return data.template;
}

export async function updateBannerLayoutTemplate(
  id: string,
  patch: { name?: string; layout?: BannerLayout },
): Promise<BannerLayoutTemplate> {
  const { data } = await apiClient.patch<{ template: BannerLayoutTemplate }>(`/banner-layouts/${id}`, patch);
  return data.template;
}

export async function deleteBannerLayoutTemplate(id: string): Promise<void> {
  await apiClient.delete(`/banner-layouts/${id}`);
}

/** チーム共有 (段階2): テンプレートのガイド PNG を共有フォルダの素材にする。共有するたびに新しい素材ができる */
export async function shareBannerLayoutTemplate(id: string): Promise<{ id: string; name: string | null }> {
  const { data } = await apiClient.post<{ material: { id: string; name: string | null } }>(`/banner-layouts/${id}/share`);
  return data.material;
}
